var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"transform":"none"}},[_c('el-input',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"input":function($event){return _vm.onChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }